/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemSellTypeWithRelations } from '../../models/item-sell-type-with-relations';

export interface GetItemSellTypeList$Params {
}

export function getItemSellTypeList(http: HttpClient, rootUrl: string, params?: GetItemSellTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemSellTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getItemSellTypeList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemSellTypeWithRelations>>;
    })
  );
}

getItemSellTypeList.PATH = '/admin/item-sell-types';
